import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {clientSummaryMetricsByIdByCompetency} from '/redux/selector/metric.clients.selector';
import {withProps} from '/util/selector.util';

import ClientsSummaryCard from './ClientsSummaryCard';

const getCompetencyByUserId = withProps({coachId: userId})(competencyById);

export default connect(
  createStructuredSelector({
    currentUserCompetency: getCompetencyByUserId,
    metrics: withProps({
      coachId: userId,
      competency: getCompetencyByUserId,
    })(clientSummaryMetricsByIdByCompetency),
  }),
)(ClientsSummaryCard);
